import NotificationSettingsApi from 'api/notification/Settings';
import { getOverviewPathFromType } from 'Config/authenticated/dictionary/overviewPath';
import { getAction } from 'Config/authenticated/dictionary/action';
import { importStatus } from 'stores/settings/settingsImportsStore';
import { EVENT_TYPES } from 'Dictionaries/notification/NotificationEnums';

export default class Notification {
    constructor(data) {
        this.event = data.event ?? null;
        this.notifId = data.recipient_id ?? data.id;
        this.sender = data.sender;
        this.linkedObject = data.linkedObject ?? data.related[0];
        this.isSystem = false;
        this.read = data.read ?? null;
        this.customizeNotification(data);
        this.onClick = null;
    }
    customizeNotification(data) {
        switch (data.event) {
            case EVENT_TYPES.MENTION_STAFF:
                this.message = getAction(data.event);
                this.path = getOverviewPathFromType({
                    type: this.linkedObject.type,
                    id: this.linkedObject.id,
                    redirectQuery: { comment: data.annotation_id ?? data.id },
                    redirectTab: '&tab=tabcomments',
                    redirectTabPurchase: '&tab=activity',
                });
                break;
            case EVENT_TYPES.IMPORT_NOTIFICATION: {
                const status = data.event_details?.status ?? data.status;
                if ([importStatus.PROCESSING, importStatus.REVERTING].includes(status)) {
                    this.message = window.i18n.__(
                        'Le traitement vient de débuter. Vous serez notifié lors de chaque changement de statut.',
                    );
                } else if ([importStatus.PROCESSED, importStatus.REVERTED].includes(status)) {
                    const invalidRows = data.event_details?.invalid_rows ?? data.invalid_rows;
                    this.message =
                        invalidRows > 0
                            ? window.i18n.__(
                                  'Le traitement est terminé et une ou des erreurs ont été détectées.',
                              )
                            : window.i18n.__(
                                  'Le traitement est terminé et aucune erreur n’a été détectée.',
                              );
                }
                this.path = `/settings/imports?import=${this.linkedObject.id}`;
                this.isSystem = true;
                break;
            }
            case EVENT_TYPES.THIRD_AUTHORIZATION_ACCEPTED: {
                /* PATH: from support ticket or customer file */
                this.path = getOverviewPathFromType({
                    type: this.linkedObject.type,
                    id: this.linkedObject.id,
                });
                this.targetedStaff = data.targeted_staff ?? data.targetedStaff ?? null;
                this.message = window.i18n.__('a autorisé la connexion à son compte');
                this.isSystem = true;
                break;
            }
            case EVENT_TYPES.THIRD_AUTHORIZATION_REFUSED: {
                /* PATH: from support ticket or customer file */
                this.path = getOverviewPathFromType({
                    type: this.linkedObject.type,
                    id: this.linkedObject.id,
                });
                this.targetedStaff = data.targeted_staff ?? data.targetedStaff ?? null;
                this.message = window.i18n.__('a refusé la connexion à son compte');
                this.isSystem = true;
                break;
            }
            case EVENT_TYPES.EMAIL_RECEIVED_NOTIFICATION: {
                const emailLinkedObjectType =
                    data.event_details?.email_linked_object_subtype ??
                    data.event_details?.email_linked_object_type ??
                    data.email_linked_object_subtype ??
                    data.email_linked_object_type;
                const emailLinkedObjectId =
                    data.event_details?.email_linked_object_id ?? data.email_linked_object_id;
                const emailCard = data.event_details?.object_id ?? data.object_id;

                if (emailLinkedObjectType && emailLinkedObjectId) {
                    this.path = getOverviewPathFromType({
                        type: 'email',
                        subType: emailLinkedObjectType,
                        id: emailLinkedObjectId,
                        redirectQuery: {
                            email: emailCard,
                            redirectTab: 'emailreceived',
                        },
                        redirectTab: '&tab=emailreceived',
                        redirectTabPurchase: '&tab=emailBox',
                    });
                }
                this.notif = data;
                break;
            }
            case EVENT_TYPES.EMAIL_SEND_ERROR_NOTIFICATION: {
                const emailLinkedObjectType =
                    data.event_details?.email_linked_object_subtype ??
                    data.email_linked_object_subtype;
                const emailLinkedObjectId =
                    data.event_details?.email_linked_object_id ?? data.email_linked_object_id;
                const emailCard = data.event_details?.object_id ?? data.object_id;

                if (emailLinkedObjectType && emailLinkedObjectId) {
                    this.path = getOverviewPathFromType({
                        type: 'email',
                        subType: emailLinkedObjectType,
                        id: emailLinkedObjectId,
                        redirectQuery: {
                            email: emailCard,
                            redirectTab: 'emailsent',
                        },
                        redirectTab: '&tab=emailsent',
                        redirectTabPurchase: '&tab=emailBox',
                    });
                }
                this.notif = data;
                this.message = window.i18n.__(
                    'Un email n’a pas pu être envoyé. Consultez l’activité pour en savoir plus',
                );
                this.isSystem = true;
                break;
            }
        }
    }

    /**
     * Call the notification settings route to check if do_not_disturb is checked or not and store the result in user store
     * @returns {Promise}
     */
    feedNotificationSettingsInStore() {
        return new Promise((resolve) => {
            NotificationSettingsApi.getNotificationsSettings().then((res) => {
                window.sellsyapp.$store.state.user.notifications = res.data;
                resolve();
            });
        });
    }

    /**
     * Notification with banner
     * templateMessage : String
     * duration : Int
     */
    notify() {
        if (!window.sellsyapp.$store.state.user.notifications) {
            this.feedNotificationSettingsInStore().then(() => this.notify());
        } else if (!window.sellsyapp.$store.state.user.notifications.do_not_disturb.enabled) {
            window.sellsyapp.$events.trigger('notification:unread:increment');
            window.sellsyapp.$events.trigger('notification:push', this);
            window.sellsyapp.$trigger('notify:new', {
                notifId: this.notifId,
                data: {
                    linkedObject: this.linkedObject,
                    sender: this.sender,
                    message: this.message,
                    path: this.path,
                    event: this.event,
                    targetedStaff: this.targetedStaff,
                    notif: this.notif,
                    onClick: this.onClick,
                },
                isSystemNotif: this.isSystem,
            });
        }
    }
}
